module.exports = __webpack_public_path__ + "img/26.08b32f99.jpg";